<ng-template #commonFilters let-report let-type="type">

  <ng-container *ngTemplateOutlet="presetTemplate; context: { $implicit: report, type: type }"></ng-container>

  <!-- <ngx-form-text title="Report name override" [(value)]="report.nameOverride"></ngx-form-text> -->
  <ngx-form-dropdown title="Issuer" [(value)]="report.issuer" [options]="issuerOptions">
  </ngx-form-dropdown>

  <!-- <ngx-doc-form-filter-select *ngIf="type != 'noninvoiced'" title="Customer"  noBorder="true" [(value)]="report.customer" [options]="businessOptions">
  </ngx-doc-form-filter-select> -->
  <ngx-form-multi-select [checkbox]="true" title="Customer(s)" [(value)]="report.customers" [options]="businessOptionsMulti"></ngx-form-multi-select>

  <div class="mt-1"></div>
  <ngx-form-dropdown title="Area sales manager" [(value)]="report.manager" [options]="userContactOptions">
  </ngx-form-dropdown>
  <ngx-form-check *ngIf="type != 'pricematrix'" title="Sort by sales manager" [(value)]="report.sortByManager"></ngx-form-check>
  <ngx-form-check *ngIf="type != 'pricematrix'" title="Filter internal documents" [(value)]="report.filterInternal"></ngx-form-check>

  <!-- <ngx-form-dropdown *ngIf="type != 'noninvoiced'" title="BusinessUnit" [(value)]="report.businessUnit" [options]="businessUnitOptions">
  </ngx-form-dropdown> -->
  <ngx-form-multi-select [checkbox]="true" title="Business Unit(s)" [(value)]="report.businessUnits" [options]="businessUnitOptionsMulti"></ngx-form-multi-select>

  <!-- <ngx-form-column-select title="FinishedProduct" [textfield]="true" (productSelected)="report.finishedProduct = $event" [businesses]="businesses" [finishedProductNames]="finishedProductNames">
  </ngx-form-column-select> -->
  <div class="mt-1"></div>
  <ngx-doc-form-filter-select title="Country"  [noBorder]="true" [(value)]="report.country" [options]="countryOptions">
  </ngx-doc-form-filter-select>

  <ngx-form-multi-select
    title="Finished product" [checkbox]="true" [mode]="'column-select'" [(value)]="report.finishedProducts" [options]="finishedProductOptionsMulti">
  </ngx-form-multi-select>
  <div class="mt-1"></div>
  <ngx-form-column-select *ngIf="type == 'noninvoiced'"
    title="Trial" [textfield]="true"  [trial]="true" (productSelected)="report.trial = $event">
  </ngx-form-column-select>

  <div *ngIf="type != 'pricematrix'" class="row">
    <div class="col-md-4">Sample request</div>
    <div class="col-md-8">
      <nb-radio-group [name]="type" class="row col-md-8" [(ngModel)]="report.sampleRequest">
        <nb-radio [value]="1" checked>All (SR & no SR)</nb-radio>
        <nb-radio [value]="2">SR only</nb-radio>
        <nb-radio [value]="3">no SR</nb-radio>
      </nb-radio-group>
    </div>
  </div>

  <ngx-form-multi-select [checkbox]="true" title="Customer reference: Document number" [(value)]="report.customerDocumentNumbers" [options]="customerDocOptionsMulti"></ngx-form-multi-select>

</ng-template>

<ng-template #presetTemplate let-report let-type="type">
  <ngx-doc-form-filter-select title="Preset" [noBorder]="true" [(value)]="reportPreset[type]" [options]="reportPresetOptions[type]" (valueChange)="presetChanged(type, $event)">
  </ngx-doc-form-filter-select>
  <div class="row">
    <div class="col-md-4"></div>
    <div class="row col-md-8">
      <div class="ml-3" style="width:calc(100% - 5rem)"><ngx-doc-form-texfield class="fullwidth" [(value)]="reportPreset[type]" placeholder="Preset name"></ngx-doc-form-texfield></div>
      <div><button class="nrk-button ml-2" (click)="addPreset(report, type)" title="Add current filters as new preset / modify existing preset">+</button></div>
      <div><button class="nrk-button ml-2" (click)="removePreset(report, type)" title="Remove preset">-</button></div>
    </div>
  </div>
  <hr style="border-style:none;border-top:1px dashed #eee">
</ng-template>

<ng-template #footer let-report let-type="type" let-xls="xls" let-extxls="extxls" let-projectOverview="projectOverview" let-pdf="pdf" let-smoffer="smoffer" let-deliveryStatus="deliveryStatus">
  <div class="row justify-content-center">
      <button *ngIf="xls" class="btn btn-primary btn-lg" (click)="onToggleExcel(type, report)">Table preview</button>
      <button *ngIf="deliveryStatus" class="btn btn-primary btn-lg" (click)="report.noPrices = false; onToggleExcel(type, report, false, 5)">Delivery Status</button>
      <button *ngIf="[1, 12, 123].includes(extxls)" class="btn btn-primary btn-lg" (click)="onToggleExcel(type, report, false, 1)">Extended table preview</button>
      <button *ngIf="[2, 12, 123].includes(extxls)" class="btn btn-primary btn-lg" (click)="onToggleExcel(type, report, false, 2)">Extended table preview (2)</button>
      <button *ngIf="[4, 13, 123].includes(extxls)" class="btn btn-primary btn-lg" (click)="onToggleExcel(type, report, false, 4)">Extended table preview (3)</button>
      <button *ngIf="[3, 13, 123].includes(extxls)" class="btn btn-primary btn-lg" (click)="onToggleExcel(type, report, false, 3)">Timeline</button>
      <button *ngIf="projectOverview" class="btn btn-primary btn-lg" (click)="onToggleExcel(type, report)">Project Overview</button>
      <button *ngIf="projectOverview" class="btn btn-primary btn-lg" (click)="onToggleExcel(type, report, false, 6)">Machinery Project Overview</button>
      <button *ngIf="pdf" class="btn btn-primary btn-lg" (click)="onTogglePrinter(type, report)">PDF preview</button>
      <button *ngIf="type === 'noninvoiced' || projectOverview" class="btn btn-primary btn-lg" (click)="onTogglePrinter(type, report, false, 401)">OC Machinery PDF by Manager</button>
      <button *ngIf="type === 'noninvoiced' || projectOverview" class="btn btn-primary btn-lg" (click)="onTogglePrinter(type, report, false, 402)">OC Machinery PDF</button>
      <button *ngIf="smoffer" class="btn btn-primary btn-lg" (click)="onTogglePrinter(type, report, false, 1)">Default SM preview</button>
  </div>
</ng-template>

<!-- sidebar -->

<ng-sidebar-container>
  <ng-sidebar *ngIf="sideBarShow" [(opened)]="sideBarOpen" position="right" [animate]="sideBarAnimate"
    [keyClose]="false">
    <div class="sidebar-fix">
      <div *ngIf="selected!=null">
        <ng-container *ngIf="reportType == 'customeroverview'; then customerPrinter; else reportsPrinter"></ng-container>
      </div>
    </div>
  </ng-sidebar>

  <div id="sidebarContent" ng-sidebar-content>
    <ngx-page-container>
      <h1>Reports</h1>
      <hr>
      <button class="btn btn-info btn-md" (click)="generateWeeklyReports()">Generate weekly reports</button>
      <button class="btn btn-info btn-md" (click)="generateWeeklyReports('NRKJ')">Generate NRKJ report</button>
      <button class="btn btn-info btn-md" (click)="generateWeeklyReports('NRKV')">Generate NRKV report</button>
      <hr>
      <ngx-form-text title="Report date / name override" [(value)]="nameOverride"></ngx-form-text>
      <hr>

      <nb-accordion>

        <!-------------------------------------------------------- offers --------------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('OF')">
          <nb-accordion-item-header>Offers</nb-accordion-item-header>
          <nb-accordion-item-body>

            <ng-container *ngTemplateOutlet="commonFilters; context: { $implicit: report.offers, type: 'offers' }"></ng-container>

            <!-- <ngx-form-dropdown title="Offer status" [options]="offerStatusOptions" [value]="report.offers.offerStatus" (valueChange)="report.offers.offerStatus = +$event"></ngx-form-dropdown> -->
            <div class="row">
              <div class="col-md-4">Offer status</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-12">
                  <label *ngFor="let status of offerStati; let idx = index"><input type="checkbox" [(ngModel)]="report.offers.offerStatus[idx]" />{{status.name}}</label>
                </div>
              </div>
            </div>


            <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.offers.dateType" (valueChange)="dateSelectionChanged(report.offers, $event)"></ngx-form-dropdown>
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-8">
                <nb-radio-group name="spodate" class="row col-md-8" [(ngModel)]="report.offers.dateField">
                  <nb-radio value="issueDate" checked>Issue date</nb-radio>
                  <nb-radio value="offerValidity">Offer validity date</nb-radio>
                </nb-radio-group>
              </div>
            </div>         
            <ngx-form-js-date [title]="(report.offers.dateField === 'issueDate' ? 'Issue' : 'Offer validity') + ' date from'" [(value)]="report.offers.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date [title]="(report.offers.dateField === 'issueDate' ? 'Issue' : 'Offer validity') + ' date to'" [(value)]="report.offers.dateTo"></ngx-form-js-date>

            <div class="row">
              <div class="col-md-4">Sort order</div>
              <div class="col-md-8">
                <nb-radio-group name="offsort" class="row col-md-8" [(ngModel)]="report.offers.sortOrder">
                  <!-- <nb-radio [value]="1">None</nb-radio> -->
                  <nb-radio [value]="3">Oldest to newest</nb-radio>
                  <nb-radio [value]="2">Newest to oldest</nb-radio>
                  <nb-radio [value]="4">Offer validity</nb-radio>
                </nb-radio-group>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.offers, type: 'offers', xls: true, extxls: 1, pdf: true, smoffer: true }"></ng-container>

          </nb-accordion-item-body>
        </nb-accordion-item>

        <!-------------------------------------------------------- orders --------------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('OR')">
          <nb-accordion-item-header>Orders</nb-accordion-item-header>
          <nb-accordion-item-body>

            <ng-container *ngTemplateOutlet="commonFilters; context: { $implicit: report.orders, type: 'orders' }"></ng-container>

            <div class="mt-1"></div>
            <ngx-doc-form-filter-select title="Order number"  [noBorder]="true" 
              [(value)]="report.orders.order" 
              [options]="ocOptions" 
              [separator]="'|'"
              (valueChange)="orderChanged($event)"
            >
            </ngx-doc-form-filter-select>

            <ngx-form-check title="Order not completed" [(value)]="report.orders.orNotCompleted"></ngx-form-check>

            <ngx-form-check title="Orders without OC only" [(value)]="report.orders.noOC"></ngx-form-check>

            <div class="row">
              <div class="col-md-4">Related Order Confirmations</div>
              <div class="col-md-8">
                <nb-radio-group name="relocs" class="row col-md-8" [(ngModel)]="report.orders.relatedOcs"
                  (ngModelChange)="$event === 1;report.orders.relatedInvoices = report.orders.relatedCreditNotes = report.orders.relatedSPOs = 1">
                  <nb-radio [value]="1" checked>None</nb-radio>
                  <nb-radio [value]="2">All</nb-radio>
                  <nb-radio [value]="3">Non Invoiced Only</nb-radio>
                </nb-radio-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">Related Invoices</div>
              <div class="col-md-8">
                <nb-radio-group name="relinvs" class="row col-md-8" [(ngModel)]="report.orders.relatedInvoices"
                  [disabled]="report.orders.relatedOcs === 1"
                  (ngModelChange)="$event === 1;report.orders.relatedCreditNotes = report.orders.relatedSPOs = 1">
                  <nb-radio [value]="1" checked >None</nb-radio>
                  <nb-radio [value]="2">All</nb-radio>
                  <nb-radio [value]="11">Not Paid</nb-radio>
                  <nb-radio [value]="12">Partially Paid</nb-radio>
                  <nb-radio [value]="13">Fully Paid</nb-radio>
                </nb-radio-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">Related Credit Notes</div>
              <div class="col-md-8">
                <nb-radio-group name="relcns" class="row col-md-8" [(ngModel)]="report.orders.relatedCreditNotes"
                  [disabled]="report.orders.relatedInvoices === 1"
                  (ngModelChange)="$event === 1;report.orders.relatedSPOs = 1">
                  <nb-radio [value]="1" checked >None</nb-radio>
                  <nb-radio [value]="2">All</nb-radio>
                </nb-radio-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">Related (PF)SPOs</div>
              <div class="col-md-8">
                <nb-radio-group name="relspos" class="row col-md-8" [(ngModel)]="report.orders.relatedSPOs"
                  [disabled]="report.orders.relatedCreditNotes === 1">
                  <nb-radio [value]="1" checked>None</nb-radio>
                  <nb-radio [value]="2">All</nb-radio>
                </nb-radio-group>
              </div>
            </div>
            <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.orders.dateType" (valueChange)="dateSelectionChanged(report.orders, $event)"></ngx-form-dropdown>
            <!-- <ngx-form-js-date title="Issue date from" [(value)]="report.orders.issueDateFrom" [disabled]="report.orders.order"></ngx-form-js-date>
            <ngx-form-js-date title="Issue date to" [(value)]="report.orders.issueDateTo" [disabled]="report.orders.order"></ngx-form-js-date> -->
            <ngx-form-js-date title="PO Date From" [(value)]="report.orders.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="PO Date Date To" [(value)]="report.orders.dateTo"></ngx-form-js-date>

            <div class="row">
              <div class="col-md-4">Show Markup</div>
              <div class="col-md-8">
                <nb-radio-group name="showmarkup" class="row col-md-8" [(ngModel)]="report.orders.showMarkup">
                  <nb-radio [value]="1">No Markup</nb-radio>
                  <nb-radio [value]="2">Markup</nb-radio>
                  <nb-radio [value]="3" checked>Markup Split per OC</nb-radio>
                </nb-radio-group>
              </div>
            </div>

            <br>

            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.orders, type: 'orders', xls: true, pdf: true }"></ng-container>
          </nb-accordion-item-body>
        </nb-accordion-item>


        <!------------------------------------------- non invoiced order confirmations --------------------------------------------------->
        <!------------------------------------------- delivery notes --------------------------------------------------->
        <!------------------------------------------- project overview --------------------------------------------------->

        <ng-template #niocdn let-section="section">

          <ng-container *ngTemplateOutlet="commonFilters; context: { $implicit: report[section], type: section }"></ng-container>

          <div class="mt-1"></div>
          <ngx-doc-form-filter-select title="Customer reference: Name" [noBorder]="true" [options]="businessOptions"
            [(value)]="report[section].customerReference" (valueChange)="customerRefChanged($event)">
          </ngx-doc-form-filter-select>
          <!-- <ngx-doc-form-filter-select title="Customer reference: Document number" noBorder="true" [options]="customerDocOptions"
            [(value)]="report[section].customerDocumentNumber">
          </ngx-doc-form-filter-select> -->

          <ngx-doc-form-filter-select title="Place of loading" [noBorder]="true" [options]="businessOptions"
            [(value)]="report[section].placeOfLoading">
          </ngx-doc-form-filter-select>

          <br>
          <ngx-form-multi-select [checkbox]="true" title="Grouped shipment(s)" [(value)]="report[section].combinedShipments" mode="cs-select" [options]="csOptions"></ngx-form-multi-select>

          <div class="mt-1"></div>
          <ngx-form-text [(value)]="report[section].internal" title="Internal"></ngx-form-text>

          <ngx-form-text [(value)]="report[section].supplierRef" title="Quotation reference"></ngx-form-text>

          <div class="row">
            <div class="col-md-4">Show unconfirmed dispatch dates</div>
            <div class="col-md-8">
              <nb-radio-group [name]="'ddunconfirmed' + section" class="row col-md-8" [(ngModel)]="report[section].showUnconfirmed">
                <nb-radio [value]="1">Yes</nb-radio>
                <nb-radio [value]="2">No</nb-radio>
                <nb-radio [value]="3">Unconfirmed only</nb-radio>
              </nb-radio-group>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-md-4">Fiscal Year</div>
            <div class="col-md-8">
              <ngx-doc-form-dropdown [(value)]="report[section].fiscalYear" [options]="fiscalYearOptions"></ngx-doc-form-dropdown>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">Don't show manually closed projects</div>
            <div class="col-md-8">
              <div class="checkbox row col-md-12">
                <label><input type="checkbox" [(ngModel)]="report[section].filterCompletedProjects" />Don't show manually closed projects</label>
              </div>
            </div>
          </div>


          <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report[section].dateType" (valueChange)="dateSelectionChanged(report[section], $event)"></ngx-form-dropdown>

          <!-- <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-8">
              <nb-radio-group name="noninvdate" class="row col-md-8" [(ngModel)]="report[section].dateField">
                <nb-radio [value]="1">Delivery Date</nb-radio>
                <nb-radio [value]="2">Dispatch date</nb-radio>
              </nb-radio-group>
            </div>
          </div> -->

          <!-- <ngx-form-js-date [title]="(report[section].dateField == 1 ? 'Dispatch' : 'Delivery') + ' date from'"
            [(value)]="report[section].dateFrom"></ngx-form-js-date>
          <ngx-form-js-date [title]="(report[section].dateField == 1 ? 'Dispatch' : 'Delivery') + ' date to'"
            [(value)]="report[section].dateTo"></ngx-form-js-date> -->


          <ngx-form-js-date title="Expected next invoice date from" [(value)]="report[section].dateFrom"></ngx-form-js-date>
          <ngx-form-js-date title="Expected next invoice date to" [(value)]="report[section].dateTo"></ngx-form-js-date>

          <ngx-form-js-date title="PO date from" [(value)]="report[section].poDateFrom"></ngx-form-js-date>
          <ngx-form-js-date title="PO date to" [(value)]="report[section].poDateTo"></ngx-form-js-date>

          <ngx-form-check title="Show related PFSPOs" [(value)]="report[section].showRelatedPFSPOs"></ngx-form-check>
 
          <ng-container *ngIf="section === 'noninvoiced'">
            <ngx-form-check title="Show invoiced OCs" [(value)]="report[section].showInvoicedOCs"></ngx-form-check>
          </ng-container>

          <ngx-form-check title="Only show OCs, if associated PFSPO is NOT confirmed"
            [(value)]="report[section].notConfirmedOCsOnly"
            (valueChange)="report[section].showRelatedPFSPOs = true">
          </ngx-form-check>

          <ngx-form-check title="Don't show prices" [(value)]="report[section].noPrices"></ngx-form-check>

          <div class="row" *ngIf="section === 'deliverynotes'">
            <div class="col-md-4">Invoice Status</div>
            <div class="col-md-8">
              <nb-radio-group name="invoiceStatus" class="row col-md-12" [(ngModel)]="report[section].invoiceStatus">
                <nb-radio [value]="0">Default</nb-radio>
                <nb-radio [value]="3">Invoiced</nb-radio>
                <nb-radio [value]="2">Not Invoiced</nb-radio>
                <nb-radio [value]="1">All</nb-radio>
              </nb-radio-group>
            </div>
          </div>

          <div class="row" *ngIf="section !== 'projectoverview'">
            <div class="col-md-4">Sort order</div>
            <div class="col-md-8">
              <nb-radio-group [name]="'noninvsort' + section" class="row col-md-12" [(ngModel)]="report[section].sortType">
                <nb-radio [value]="1">Dispatch date to final customer</nb-radio>
                <nb-radio [value]="3">Expected next invoice date</nb-radio>
                <nb-radio [value]="2">Customer requested delivery date</nb-radio>
              </nb-radio-group>
            </div>
          </div>

          <ngx-doc-form-filter-select *ngIf="section === 'projectoverview'" title="Sort By" [noBorder]="true" [(value)]="report[section].sortDate" [options]="datesData.getProjectOverviewOptions()"></ngx-doc-form-filter-select>
          <br>

          <div class="row">
            <div class="col-md-4 d-flex flex-wrap gap-3">Unit Filter</div>
              <label 
                *ngFor="let idx of [0, 1, 4, 2, 3, 5]" 
                class="units-label"\
              ><input type="checkbox" 
                [(ngModel)]="report[section].units[idx]" 
                [attr.disabled]="(idx !== 0 && report[section].units[0]) || null"
                (ngModelChange)="report[section].units = idx === 0 
                  ? $event 
                    ? [true, true, true, true, true, true, ] 
                    : [false, false, false, false, false, false, ]
                  : report[section].units"
                >{{['All', 'pc', 'm', '100m', 'm²', 'kg'][idx]}}
              </label>
              <!-- <label><input type="checkbox" [(ngModel)]="report[section].units[4]" [attr.disabled]="report[section].units[0] || null">m²</label>
              <label><input type="checkbox" [(ngModel)]="report[section].units[2]" [attr.disabled]="report[section].units[0] || null">m</label>
              <label><input type="checkbox" [(ngModel)]="report[section].units[3]" [attr.disabled]="report[section].units[0] || null">100m</label>
              <label><input type="checkbox" [(ngModel)]="report[section].units[5]" [attr.disabled]="report[section].units[0] || null">kg</label> -->
            <div class="col-md-8">
            </div>
          </div>
          <br>

          <div class="row" *ngIf="section !== 'projectoverview'">
            <div class="col-md-4">Unit Conversion (EM only)</div>
            <div class="col-md-8">
              <nb-radio-group [name]="'conversion' + section" class="row col-md-12" [(ngModel)]="report[section].unitConversion">
                <nb-radio [value]="null">None</nb-radio>
                <nb-radio [value]="1">pc</nb-radio>
                <nb-radio [value]="4">m²</nb-radio>
                <nb-radio [value]="2">m</nb-radio>
                <nb-radio [value]="3">100m</nb-radio>
                <nb-radio [value]="5">kg</nb-radio>
              </nb-radio-group>
            </div>
          </div>
          <br>

          <ng-container *ngTemplateOutlet="footer; context: { $implicit: report[section], type: section, xls: section !== 'projectoverview', deliveryStatus: section !== 'projectoverview', projectOverview: section === 'projectoverview', pdf: section !== 'projectoverview' }"></ng-container>

        </ng-template>


        <nb-accordion-item [expanded]="shallExpand('NIOC')">
          <nb-accordion-item-header>Non invoiced order confirmations</nb-accordion-item-header>
          <nb-accordion-item-body>
            <div #NIOC><ng-container *ngTemplateOutlet="niocdn; context: { section: 'noninvoiced' }"></ng-container></div>
          </nb-accordion-item-body>
        </nb-accordion-item>

        <nb-accordion-item [expanded]="shallExpand('DN')">
          <nb-accordion-item-header>Delivery notes</nb-accordion-item-header>
          <nb-accordion-item-body>
            <div #DN><ng-container *ngTemplateOutlet="niocdn; context: { section: 'deliverynotes' }"></ng-container></div>
          </nb-accordion-item-body>
        </nb-accordion-item>

        <nb-accordion-item [expanded]="shallExpand('PROV')">
          <nb-accordion-item-header>Project Overview</nb-accordion-item-header>
          <nb-accordion-item-body>
            <div #PROV><ng-container *ngTemplateOutlet="niocdn; context: { section: 'projectoverview' }"></ng-container></div>
          </nb-accordion-item-body>
        </nb-accordion-item>

        <!--------------------------------------------------- open (PF)SPOs ------------------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('OSPO')">
          <nb-accordion-item-header>Open (PF)SPOs</nb-accordion-item-header>
          <nb-accordion-item-body>

            <div #OSPO>
            <ng-container *ngTemplateOutlet="presetTemplate; context: { $implicit: report.openspo, type: 'openspo' }"></ng-container>

            <ngx-form-dropdown title="Issuer" [(value)]="report.openspo.issuer" [options]="issuerOptions">
            </ngx-form-dropdown>
            <!-- <ngx-doc-form-filter-select title="Supplier"  noBorder="true" [(value)]="report.openspo.customer" [options]="businessOptions">
            </ngx-doc-form-filter-select> -->
            <ngx-form-multi-select [checkbox]="true" title="Recipient(s)" [(value)]="report.openspo.customers" [options]="businessOptionsMulti"></ngx-form-multi-select>

            <div class="row">
              <div class="col-md-4">Type of documents</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.openspo.docs.spo" />SPO</label>
                  <label><input type="checkbox" [(ngModel)]="report.openspo.docs.spc" />SPC</label>
                  <label><input type="checkbox" [(ngModel)]="report.openspo.docs.pfspo" />PFSPO</label>
                  <label><input type="checkbox" [(ngModel)]="report.openspo.docs.pfspc" />PFSPC</label>
                  <!-- <label><input type="checkbox" [(ngModel)]="report.openspo.docs.oc" />OC</label> -->
                </div>
              </div>
            </div>

            <!-- <ngx-form-check title="Show related order confirmations" [(value)]="report.openspo.showRelatedOCs"></ngx-form-check> -->
            <div class="row">
              <div class="col-md-4">Show related order confirmations</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.openspo.showRelatedOCs" />OC</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">(PF)SPO Filter</div>
              <div class="col-md-8">
                <nb-radio-group name="spoWithOC" class="row col-md-8" [(ngModel)]="report.openspo.spoWithOC">
                  <nb-radio [value]="1" checked>All</nb-radio>
                  <nb-radio [value]="2">(PF)SPO without OC</nb-radio>
                  <nb-radio [value]="3">(PF)SPO with OC</nb-radio>
                </nb-radio-group>
              </div>
            </div> 

            <div class="row">
              <div class="col-md-4">Sample request</div>
              <div class="col-md-8">
                <nb-radio-group name="sposr" class="row col-md-8" [(ngModel)]="report.openspo.sampleRequest">
                  <nb-radio [value]="1" checked>All (SR & no SR)</nb-radio>
                  <nb-radio [value]="2">SR only</nb-radio>
                  <nb-radio [value]="3">no SR</nb-radio>
                </nb-radio-group>
              </div>
            </div>         
            <!-- <ngx-doc-form-filter-select title="Combined shipment"  noBorder="true" [(value)]="report.openspo.combinedShipment" [options]="csOptions">
            </ngx-doc-form-filter-select> -->

            <ngx-form-multi-select
              title="Finished product" [checkbox]="true" [mode]="'column-select'" [businessId]="report.openspo.customers?.[0]" [(value)]="report.openspo.finishedProducts" [options]="finishedProductOptionsMulti">
            </ngx-form-multi-select>
        

            <div class="row">
              <div class="col-md-4">Grouped shipment</div>
              <div class="col-md-8" style="position:relative; height:2.7em">
                <div style="position:absolute;z-Index:5;width:100%;padding-right:4.5em">
                  <ngx-document-cs-selector
                    title="Select Grouped Shipment"
                    [abstractItem]="report.openspo.combinedShipment"
                    [mode]="selectorDisplayMode.input"
                    [latestVersionItems]="$any(csOptions)"
                    (compilationChange)="report.openspo.combinedShipment = $event.code"
                  ></ngx-document-cs-selector>
                  <button style="position:absolute;right:32px;top:6px;" class="nrk-doc-button" (click)="report.openspo.combinedShipment = null" >X</button>
                </div>
              </div>
            </div>

            <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.openspo.dateType" (valueChange)="dateSelectionChanged(report.openspo, $event)"></ngx-form-dropdown>
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-8">
                <nb-radio-group name="spodate" class="row col-md-8" [(ngModel)]="report.openspo.dateField">
                  <nb-radio [value]="2" checked>Dispatch date</nb-radio>
                  <nb-radio [value]="1">EXW date</nb-radio>
                </nb-radio-group>
              </div>
            </div>         
            <ngx-form-js-date [title]="report.openspo.dateField == 1 ? 'EXW date from' : 'Dispatch date from'" [(value)]="report.openspo.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date [title]="report.openspo.dateField == 1 ? 'EXW date to' : 'Dispatch date to'" [(value)]="report.openspo.dateTo"></ngx-form-js-date>
            <!-- <ngx-form-js-date title="EXW date from" [(value)]="report.openspo.exwDateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="EXW date to" [(value)]="report.openspo.exwDateTo"></ngx-form-js-date> -->
            <!-- <ngx-form-check title="Cluster in CS" [(value)]="report.openspo.clusterInCs"></ngx-form-check> -->
            <div class="row">
              <div class="col-md-4">All Documents</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.openspo.allDocs" />Documents without date included</label>
                </div>
              </div>
            </div>

            <ngx-doc-form-filter-select title="Document number" [noBorder]="true" [options]="documentNumberOptions"
            [(value)]="report.openspo.documentNumber"></ngx-doc-form-filter-select>

            <ngx-doc-form-filter-select title="Transportation"  [noBorder]="true" [(value)]="report.openspo.meansOfTransport" [options]="meansOfTransportOptions"></ngx-doc-form-filter-select>
            <div class="row">
              <div class="col-md-4">SPO Status</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.openspo.spoStatus.unconfirmed" />Unconfirmed</label>
                  <label><input type="checkbox" [(ngModel)]="report.openspo.spoStatus.confirmed" />Confirmed</label>
                  <!-- <label><input type="checkbox" [(ngModel)]="report.openspo.spoStatus.completed" />Completed</label> -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">Transport Status</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.openspo.transportStatus.planned" />Planned</label>
                  <label><input type="checkbox" [(ngModel)]="report.openspo.transportStatus.enRoute" />En route</label>
                  <label><input type="checkbox" [(ngModel)]="report.openspo.transportStatus.completed" />Completed</label>
                </div>
              </div>
            </div>

            <ngx-form-text title="OBIC" [(value)]="report.openspo.obic"></ngx-form-text>
            <!-- <ngx-doc-form-filter-select title="Customer selection:" noBorder="true" [options]="customerRefOptions"
              (valueChange)="onCustomerRef(report.openspo, $event);">
            </ngx-doc-form-filter-select> -->
            <!-- <ngx-form-text title="Customer reference: Name" [(value)]="report.openspo.customerName"></ngx-form-text> -->
            <div class="mt-1"></div>
            <ngx-doc-form-filter-select title="Customer reference: Name" [noBorder]="true" [options]="businessOptions"
              [(value)]="report.openspo.customerReference" (valueChange)="customerRefChanged($event)">
            </ngx-doc-form-filter-select>
            <!-- <ngx-form-text title="Customer reference: Document number" [(value)]="report.openspo.customerDocumentNumber"></ngx-form-text> -->
            <ngx-doc-form-filter-select title="Customer reference: Document number" [noBorder]="true" [options]="customerDocOptions"
              [(value)]="report.openspo.customerDocumentNumber">
            </ngx-doc-form-filter-select>
            <!-- <ngx-form-column-select title="FinishedProduct" [textfield]="true" (productSelected)="report.openspo.finishedProduct = $event" [businesses]="businesses" [finishedProductNames]="finishedProductNames">
            </ngx-form-column-select>   -->
            <!-- <ngx-form-multi-select title="Finished product" [mode]="'column-select'" [(value)]="report.openspo.finishedProducts" [businesses]="businesses" [finishedProductNames]="finishedProductNames">
            </ngx-form-multi-select> -->

            <ngx-form-check title="Don't show prices" [(value)]="report.openspo.noPrices"></ngx-form-check>

            <div class="row" style="margin-top:5px">
              <div class="col-md-4">PFSPO Availability</div>
              <div class="col-md-8">
                <div class="col-md-8">
                  <nb-radio-group name="availablility" class="row" [(ngModel)]="report.openspo.availabilityStatus">
                    <!-- <nb-radio [value]="1">Default</nb-radio> -->
                    <nb-radio [value]="null">All</nb-radio>
                    <nb-radio [value]="1">Not completed</nb-radio>
                    <nb-radio [value]="2">Completed</nb-radio>
                  </nb-radio-group>
                </div>
              </div>
            </div>
            <br>

            <div class="row" style="margin-top:5px">
              <div class="col-md-4">Sort order</div>
              <div class="col-md-8">
                <div class="col-md-8">
                  <nb-radio-group name="sposort" class="row col-md-10" [(ngModel)]="report.openspo.sortType">
                    <nb-radio [value]="5">Pickup date, Transportation, CS #, PFSPO # &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</nb-radio>
                    <nb-radio [value]="1">EXW date, Transportation, CS #, PFSPO # &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</nb-radio>
                    <nb-radio [value]="7">ETA AT, Transportation, CS#, PFSPO# &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</nb-radio>
                    <nb-radio style="margin-right:20em" [value]="2">Document #</nb-radio>
                    <nb-radio style="margin-right:15em" [value]="3">Dispatch date, Document #</nb-radio>
                    <nb-radio style="margin-right:18em" [value]="6">Customer reference: Name</nb-radio>
                    <!-- <nb-radio [value]="4">Customer requested delivery date, Document #</nb-radio> -->
                    <nb-radio [value]="7">box age</nb-radio>
                  </nb-radio-group>
                </div>
              </div>
            </div>
            <br>

            <div class="row" style="margin-top:5px">
              <div class="col-md-4">Timeline</div>
              <div class="col-md-8">
                <div class="col-md-8">
                  <nb-radio-group name="sposort" class="row" [(ngModel)]="report.openspo.sortType">
                    <!-- <nb-radio [value]="1">Default</nb-radio> -->
                    <nb-radio [value]="101">Sort by customer</nb-radio>
                    <nb-radio [value]="102">Sort by Product</nb-radio>
                  </nb-radio-group>
                </div>
              </div>
            </div>
            <br>

            <div *ngIf="jsonParams?.combinedShipment" style="text-align:center; margin: 0 auto;">
              <button class="btn btn-secondary btn-sm" (click)="openReferrerDocument()">Back to CS/GS</button>
            </div>
          
            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.openspo, type: 'openspo', xls: true, extxls: 123, pdf: true }"></ng-container>
            </div>
          </nb-accordion-item-body>
        </nb-accordion-item>
        
        <!-- <nb-accordion-item [expanded]="shallExpand('OSPO')">
          <nb-accordion-item-header>Open (PF)SPOs</nb-accordion-item-header>
          <nb-accordion-item-body>
            <div class="row">
              <div class="col-md-4">Document type</div>
              <div class="col-md-8">
                <nb-radio-group class="row col-md-8" [(ngModel)]="report.openspo.documentType">
                  <nb-radio [value]="1">SPO & PFSPO</nb-radio>
                  <nb-radio [value]="2">SPO</nb-radio>
                  <nb-radio [value]="3">PFSPO</nb-radio>
                </nb-radio-group>
              </div>
            </div>
            <div>&nbsp;</div>
            <ngx-form-dropdown title="Recipient" [(value)]="report.openspo.recipient" [options]="importerOptions">
            </ngx-form-dropdown>
            <ngx-form-js-date title="Exworks date from" [(value)]="report.openspo.exwDateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Exworks date to" [(value)]="report.openspo.exwDateTo"></ngx-form-js-date>
            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.openspo, type: 'openspo', xls:true, pdf: true }"></ng-container>
          </nb-accordion-item-body>
        </nb-accordion-item> -->


        <!--------------------------------------------------- Combined Shipments Overview --------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('CS')">
          <nb-accordion-item-header>CS Overview</nb-accordion-item-header>
          <nb-accordion-item-body>

            <ng-container *ngTemplateOutlet="presetTemplate; context: { $implicit: report.cs, type: 'cs' }"></ng-container>

            <!-- <ngx-form-dropdown title="Issuer" [(value)]="report.cs.issuer" [options]="issuerOptions">
            </ngx-form-dropdown> -->

            <!-- <ngx-form-multi-select [checkbox]="true" title="Recipient(s)" [(value)]="report.cs.customers" [options]="businessOptionsMulti"></ngx-form-multi-select> -->

            <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.cs.dateType" (valueChange)="dateSelectionChanged(report.cs, $event)"></ngx-form-dropdown>
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-8">
                <nb-radio-group name="spodate" class="row col-md-8" [(ngModel)]="report.cs.dateField">
                  <nb-radio [value]="2" checked>Dispatch date</nb-radio>
                  <nb-radio [value]="1">EXW date</nb-radio>
                </nb-radio-group>
              </div>
            </div>         
            <ngx-form-js-date [title]="report.cs.dateField == 1 ? 'EXW date from' : 'Dispatch date from'" [(value)]="report.cs.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date [title]="report.cs.dateField == 1 ? 'EXW date to' : 'Dispatch date to'" [(value)]="report.cs.dateTo"></ngx-form-js-date>
            <!-- <div class="row">
              <div class="col-md-4">All Documents</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.cs.allDocs" />Documents without date included</label>
                </div>
              </div>
            </div> -->

            <ngx-doc-form-filter-select title="Transportation"  [noBorder]="true" [(value)]="report.cs.meansOfTransport" [options]="meansOfTransportOptions"></ngx-doc-form-filter-select>
            <div class="row">
              <div class="col-md-4">Transport Status</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.cs.transportStatus.planned" />Planned</label>
                  <label><input type="checkbox" [(ngModel)]="report.cs.transportStatus.enRoute" />En route</label>
                  <label><input type="checkbox" [(ngModel)]="report.cs.transportStatus.completed" />Completed</label>
                </div>
              </div>
            </div>

            <!-- <ngx-form-text title="OBIC" [(value)]="report.cs.obic"></ngx-form-text> -->

            <!-- <ngx-doc-form-filter-select title="Customer reference: Name" [noBorder]="true" [options]="businessOptions"
              [(value)]="report.cs.customerReference" (valueChange)="customerRefChanged($event)">
            </ngx-doc-form-filter-select>

            <ngx-doc-form-filter-select title="Customer reference: Document number" [noBorder]="true" [options]="customerDocOptions"
              [(value)]="report.cs.customerDocumentNumber">
            </ngx-doc-form-filter-select>

            <div class="row" style="margin-top:5px">
              <div class="col-md-4">PFSPO Availability</div>
              <div class="col-md-8">
                <div class="col-md-8">
                  <nb-radio-group name="availablility" class="row" [(ngModel)]="report.cs.availabilityStatus">
                    <nb-radio [value]="null">All</nb-radio>
                    <nb-radio [value]="1">Not completed</nb-radio>
                    <nb-radio [value]="2">Completed</nb-radio>
                  </nb-radio-group>
                </div>
              </div>
            </div>
            <br> -->

          
            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.cs, type: 'cs', xls: true, pdf: false }"></ng-container>

          </nb-accordion-item-body>
        </nb-accordion-item>
        
        <!--------------------------------------------------- Invoiced line items --------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('ILI')">
          <nb-accordion-item-header>Invoiced line items</nb-accordion-item-header>
          <nb-accordion-item-body>

            <ng-container *ngTemplateOutlet="presetTemplate; context: { $implicit: report.invoiced, type: 'invoiced' }"></ng-container>

            <!-- <ngx-doc-form-filter-select title="Customer"  [noBorder]="true" [(value)]="report.invoiced.customer" [options]="businessOptions"></ngx-doc-form-filter-select> -->
            <ngx-form-multi-select [checkbox]="true" title="Customer(s)" [(value)]="report.invoiced.customers" [options]="businessOptionsMulti"></ngx-form-multi-select>
            <div class="mt-1"></div>
            <ngx-doc-form-filter-select title="BusinessUnit"  [noBorder]="true" [(value)]="report.invoiced.businessUnit" [options]="businessUnitOptions"></ngx-doc-form-filter-select>
            <div class="row">
              <div class="col-md-4">Document status</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.invoiced.status.final" />final</label>
                  <label><input type="checkbox" [(ngModel)]="report.invoiced.status.draft" />draft</label>
                  <label><input type="checkbox" [(ngModel)]="report.invoiced.status.cancelled" />cancelled</label>
                  <label><input type="checkbox" [(ngModel)]="report.invoiced.status.revised" />revised</label>
                </div>
              </div>
            </div>

            <!-- <ngx-form-js-date title="Issue date from" [(value)]="report.invoiced.issueDateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Issue date to" [(value)]="report.invoiced.issueDateTo"></ngx-form-js-date> -->
            <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.invoiced.dateType" (valueChange)="dateSelectionChanged(report.invoiced, $event)"></ngx-form-dropdown>
            <ngx-form-js-date title="Issue date from" [(value)]="report.invoiced.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Issue date to" [(value)]="report.invoiced.dateTo"></ngx-form-js-date>

            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.invoiced, type: 'invoiced', xls: true }"></ng-container>

          </nb-accordion-item-body>
        </nb-accordion-item>

        <!--------------------------------------------------- Open orders --------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('OOR')">
          <nb-accordion-item-header>Open orders</nb-accordion-item-header>
          <nb-accordion-item-body>

            <ng-container *ngTemplateOutlet="presetTemplate; context: { $implicit: report.openorders, type: 'openorders' }"></ng-container>

            <ngx-form-check title="Show all OCs including invoiced" [(value)]="report.openorders.allOCs"></ngx-form-check>
            <!-- <ngx-doc-form-filter-select title="Customer"  [noBorder]="true" [(value)]="report.openorders.customer" [options]="businessOptions"></ngx-doc-form-filter-select> -->
            <ngx-form-multi-select [checkbox]="true" title="Customer(s)" [(value)]="report.openorders.customers" [options]="businessOptionsMulti"></ngx-form-multi-select>
            <div class="mt-1"></div>
            <ngx-doc-form-filter-select title="BusinessUnit"  [noBorder]="true" [(value)]="report.openorders.businessUnit" [options]="businessUnitOptions"></ngx-doc-form-filter-select>
            <div class="row">
              <div class="col-md-4">Document status</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.openorders.status.final" />final</label>
                  <label><input type="checkbox" [(ngModel)]="report.openorders.status.draft" />draft</label>
                  <label><input type="checkbox" [(ngModel)]="report.openorders.status.cancelled" />cancelled</label>
                  <label><input type="checkbox" [(ngModel)]="report.openorders.status.revised" />revised</label>
                </div>
              </div>
            </div>
            <!-- <ngx-form-js-date title="Delivery date from" [(value)]="report.openorders.dispatchDateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Delivery date to" [(value)]="report.openorders.dispatchDateTo"></ngx-form-js-date> -->
            <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.openorders.dateType" (valueChange)="dateSelectionChanged(report.openorders, $event)"></ngx-form-dropdown>
            <ngx-form-js-date title="Delivery date from" [(value)]="report.openorders.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Delivery date to" [(value)]="report.openorders.dateTo"></ngx-form-js-date>

            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.openorders, type: 'openorders', xls: true }"></ng-container>

          </nb-accordion-item-body>
        </nb-accordion-item>      

        <!-- <nb-radio-group [name]="type" class="row col-md-8" [(ngModel)]="report.sampleRequest">
          <nb-radio [value]="1" checked>All (SR & no SR)</nb-radio>
          <nb-radio [value]="2">SR only</nb-radio>
          <nb-radio [value]="3">no SR</nb-radio>
        </nb-radio-group> -->
  

        <!-- <nb-accordion-item [expanded]="shallExpand('ILI')">
          <nb-accordion-item-header>Invoiced line items</nb-accordion-item-header>
          <nb-accordion-item-body>
            <div class="row">
              <div class="col-md-4">Document type</div>
              <div class="col-md-8">
                <nb-radio-group class="row col-md-8" [(ngModel)]="report.invoiced.documentType">
                  <nb-radio [value]="8">Credit note</nb-radio>
                  <nb-radio [value]="5">Invoice</nb-radio>
                  <nb-radio [value]="7">Proforma invoice</nb-radio>
                </nb-radio-group>
              </div>
            </div>
            <div>&nbsp;</div>
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-8">
                <nb-checkbox [(ngModel)]="report.invoiced.finalOnly">final only</nb-checkbox>
              </div>
            </div>
            <div>&nbsp;</div>
            <ngx-form-dropdown title="Customer / supplier" [(value)]="report.invoiced.customer"
              [options]="businessOptions">
            </ngx-form-dropdown>
            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.invoiced, type: 'invoiced', xls: true }"></ng-container>
          </nb-accordion-item-body>
        </nb-accordion-item> -->

        <!--------------------------------------------------- Invoiced line items plus open orders--------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('ILIOO')">
          <nb-accordion-item-header>Invoiced line items plus open orders</nb-accordion-item-header>
          <nb-accordion-item-body>

            <ng-container *ngTemplateOutlet="presetTemplate; context: { $implicit: report.invoicedandopenorders, type: 'invoicedandopenorders' }"></ng-container>

            <ngx-form-multi-select [checkbox]="true" title="Customer(s)" [(value)]="report.invoicedandopenorders.customers" [options]="businessOptionsMulti"></ngx-form-multi-select>
            <div class="mt-1"></div>
            <ngx-form-dropdown title="Area sales manager" [(value)]="report.invoicedandopenorders.manager" [options]="userContactOptions"></ngx-form-dropdown>
            <div class="mt-1"></div>
            <ngx-doc-form-filter-select title="BusinessUnit"  [noBorder]="true" [(value)]="report.invoicedandopenorders.businessUnit" [options]="businessUnitOptions"></ngx-doc-form-filter-select>
            <div class="row">
              <div class="col-md-4">Document status</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.invoicedandopenorders.status.final" />final</label>
                  <label><input type="checkbox" [(ngModel)]="report.invoicedandopenorders.status.draft" />draft</label>
                  <label><input type="checkbox" [(ngModel)]="report.invoicedandopenorders.status.cancelled" />cancelled</label>
                  <label><input type="checkbox" [(ngModel)]="report.invoicedandopenorders.status.revised" />revised</label>
                </div>
              </div>
            </div>

            <ngx-form-multi-select
              title="Finished product" [checkbox]="true" [mode]="'column-select'" [businessId]="report.invoicedandopenorders.customers?.[0]" [(value)]="report.invoicedandopenorders.finishedProducts" [options]="finishedProductOptionsMulti">
            </ngx-form-multi-select>

            <div class="mt-1"></div>
            <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.invoicedandopenorders.dateType" (valueChange)="dateSelectionChanged(report.invoicedandopenorders, $event)"></ngx-form-dropdown>
            <ngx-form-js-date title="Dispatch date from" [(value)]="report.invoicedandopenorders.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Dispatch date to" [(value)]="report.invoicedandopenorders.dateTo"></ngx-form-js-date>

            <ngx-doc-form-filter-select title="Quantity Summary Unit"  [noBorder]="true" [(value)]="$any(report).invoicedandopenorders.quantitySummaryUnit" [options]="unitOptions"></ngx-doc-form-filter-select>

            <!-- <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.invoicedandopenorders, type: 'invoicedandopenorders', xls: true }"></ng-container> -->
            <div style="text-align: center">
              <button class="btn btn-primary btn-lg" 
               (click)="report.invoicedandopenorders.quantitySummary=false;onToggleExcel('invoicedandopenorders', report.invoicedandopenorders, false, 1)"
              >Table Preview
              </button>
              <button class="btn btn-primary btn-lg ml-2" 
               (click)="report.invoicedandopenorders.quantitySummary=true;onToggleExcel('invoicedandopenorders', report.invoicedandopenorders, false, 1)"
              >Quantity Summary
              </button>
            </div>

          </nb-accordion-item-body>
        </nb-accordion-item>

        <!--------------------------------------------------- Price matrix --------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('PM')">
          <nb-accordion-item-header>Price matrix</nb-accordion-item-header>
          <nb-accordion-item-body>

            <ng-container *ngTemplateOutlet="commonFilters; context: { $implicit: report.pricematrix, type: 'pricematrix' }"></ng-container>

            <!-- <ngx-form-dropdown title="Customer" [(value)]="report.pricematrix.customer" [options]="businessOptions">
            </ngx-form-dropdown>
            <ngx-form-js-date title="Effective date" [(value)]="report.pricematrix.effectiveDate"></ngx-form-js-date>
            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.pricematrix, type: 'pricematrix', xls: true }"></ng-container> -->
          
            <div class="mt-1"></div>
            <ngx-doc-form-filter-select title="Base product"
              [noBorder]="true" 
              [(value)]="report.pricematrix.baseProduct" 
              [options]="baseProductOptions" 
              [separator]="'|'"
              (valueChange)="orderChanged($event)"
            ></ngx-doc-form-filter-select>
         
            <div class="row">
              <div class="col-md-4">Price type</div>
              <div class="col-md-8">
                <nb-radio-group name="pricetype" class="row col-md-8" [(ngModel)]="report.pricematrix.priceType">
                  <nb-radio [value]="2">Selling</nb-radio>
                  <nb-radio [value]="3">Buying</nb-radio>
                  <nb-radio [value]="1" checked>All</nb-radio>
                </nb-radio-group>
              </div>
            </div>
          
            <ngx-form-js-date #vfDate title="Valid from date" [value]="$any(report.pricematrix.dateFrom)" (valueChange)="report.pricematrix.dateFrom=$any($event);effDate.clear()"></ngx-form-js-date>
            <ngx-form-js-date #vtDate title="Valid to date" [value]="$any(report.pricematrix.dateTo)" (valueChange)="report.pricematrix.dateTo=$any($event);effDate.clear()"></ngx-form-js-date>
            <ngx-form-js-date #effDate title="Effective date" [(value)]="report.pricematrix.effectiveDate" (valueChange)="vfDate.clear();vtDate.clear()"></ngx-form-js-date>

            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.pricematrix, type: 'pricematrix', xls: true, extxls: 1 }"></ng-container>

          </nb-accordion-item-body>
        </nb-accordion-item>
        <!-- <nb-radio-group [name]="type" class="row col-md-8" [(ngModel)]="report.sampleRequest">
          <nb-radio [value]="1" checked>All (SR & no SR)</nb-radio>
          <nb-radio [value]="2">SR only</nb-radio>
          <nb-radio [value]="3">no SR</nb-radio>
        </nb-radio-group> -->
  
        <!-- <nb-accordion-item [expanded]="shallExpand('DI')">
          <nb-accordion-item-header>Due invoices</nb-accordion-item-header>
          <nb-accordion-item-body>
            <ngx-form-dropdown title="Issuer" [(value)]="report.dueinvoices.issuer" [options]="issuerOptions">
            </ngx-form-dropdown>
            <ngx-form-dropdown title="Customer" [(value)]="report.dueinvoices.customer" [options]="businessOptions">
            </ngx-form-dropdown>
            <ngx-form-js-date title="Due date from" [(value)]="report.dueinvoices.dueDateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Due date to" [(value)]="report.dueinvoices.dueDateTo"></ngx-form-js-date>
            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.dueinvoices, type: 'dueinvoices', pdf: true }"></ng-container>

          </nb-accordion-item-body>
        </nb-accordion-item> -->

        <!--------------------------------------------------- Due invoices --------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('DI')">
          <nb-accordion-item-header>Due invoices</nb-accordion-item-header>
          <nb-accordion-item-body>

            <ng-container *ngTemplateOutlet="commonFilters; context: { $implicit: report.dueinvoices, type: 'dueinvoices' }"></ng-container>

            <div class="row">
              <div class="col-md-4">Payment status</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.dueinvoices.invoiceStatus.notPaid" />not paid</label>
                  <label><input type="checkbox" [(ngModel)]="report.dueinvoices.invoiceStatus.partiallyPaid" />partially paid</label>
                  <label><input type="checkbox" [(ngModel)]="report.dueinvoices.invoiceStatus.fullyPaid" />fully paid</label>
                  <label><input type="checkbox" [(ngModel)]="report.dueinvoices.invoiceStatus.notCollectible" />not collectible</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">Due status</div>
              <div class="col-md-8">
                <nb-radio-group name="pricetype" class="row col-md-8" [(ngModel)]="report.dueinvoices.dueStatus">
                  <nb-radio [value]="2">Only due</nb-radio>
                  <nb-radio [value]="3">Only overdue</nb-radio>
                  <nb-radio [value]="1" checked>All</nb-radio>
                </nb-radio-group>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col-md-4">Fiscal Year</div>
              <div class="col-md-8">
                <nb-radio-group name="fiscalMismatchDue" class="row col-md-8" [(ngModel)]="report.dueinvoices.fiscalYearMismatch">
                  <nb-radio [value]="1" checked>All</nb-radio>
                  <nb-radio [value]="2">Fiscal year mismatch</nb-radio>
                  <nb-radio [value]="3">Fiscal year match</nb-radio>
                </nb-radio-group>
              </div>
            </div> -->

            <div class="row mb-1">
              <div class="col-md-4">Fiscal Year</div>
              <div class="col-md-8">
                <ngx-doc-form-dropdown [(value)]="report.dueinvoices.fiscalYear" [options]="fiscalYearOptions"></ngx-doc-form-dropdown>
              </div>
            </div>

            <!-- <ngx-form-multi-select title="Finished product" [mode]="'column-select'" [(value)]="report.dueinvoices.finishedProducts" [businesses]="businesses" [finishedProductNames]="finishedProductNames"></ngx-form-multi-select> -->
            <!-- <ngx-form-js-date title="Due date from" [(value)]="report.dueinvoices.dueDateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Due date to" [(value)]="report.dueinvoices.dueDateTo"></ngx-form-js-date> -->
            <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.dueinvoices.dateType" (valueChange)="dateSelectionChanged(report.dueinvoices, $event)"></ngx-form-dropdown>
            <ngx-form-js-date title="Due date from" [(value)]="report.dueinvoices.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Due date to" [(value)]="report.dueinvoices.dateTo"></ngx-form-js-date>

            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.dueinvoices, type: 'dueinvoices', pdf: true, xls: true }"></ng-container>

          </nb-accordion-item-body>
        </nb-accordion-item>

        <!------------------------------------------------ invoices of last week ------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('ILW')">
          <nb-accordion-item-header>Invoices</nb-accordion-item-header>
          <nb-accordion-item-body>

            <ng-container *ngTemplateOutlet="commonFilters; context: { $implicit: report.lastinvoices, type: 'lastinvoices' }"></ng-container>

            <div class="row">
              <div class="col-md-4">Type of documents</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.lastinvoices.docs.in" />IN</label>
                  <label><input type="checkbox" [(ngModel)]="report.lastinvoices.docs.pfin" />PFIN</label>
                  <label><input type="checkbox" [(ngModel)]="report.lastinvoices.docs.cn" />CN</label>
                  <label><input type="checkbox" [(ngModel)]="report.lastinvoices.docs.pfcn" />PFCN</label>
                </div>
              </div>
            </div>

            <ngx-form-check title="Show related PFSPOs" [(value)]="report.lastinvoices.showRelatedPFSPOs"></ngx-form-check>

            <!-- <ngx-form-check title="Transaction receipt completed" [(value)]="report.lastinvoices.transactionReceipt"></ngx-form-check>
            <ngx-form-check title="Proof of delivery completed" [(value)]="report.lastinvoices.proveOfDelivery"></ngx-form-check>
            <ngx-form-check title="Test certificate completed" [(value)]="report.lastinvoices.testCertificate"></ngx-form-check> -->

            <div class="row">
              <div class="col-md-4">Transaction receipt completed</div>
              <div class="col-md-8">
                <nb-radio-group name="transactionReceipt" class="row col-md-8" [(ngModel)]="report.lastinvoices.transactionReceipt">
                  <nb-radio [value]="1">Yes</nb-radio>
                  <nb-radio [value]="2">No</nb-radio>
                  <nb-radio [value]="3">All</nb-radio>
                </nb-radio-group>
              </div>
            </div>
  
            <div class="row">
              <div class="col-md-4">Proof of delivery completed</div>
              <div class="col-md-8">
                <nb-radio-group name="proveOfDelivery" class="row col-md-8" [(ngModel)]="report.lastinvoices.proveOfDelivery">
                  <nb-radio [value]="1">Yes</nb-radio>
                  <nb-radio [value]="2">No</nb-radio>
                  <nb-radio [value]="3">All</nb-radio>
                </nb-radio-group>
              </div>
            </div>
  
            <div class="row">
              <div class="col-md-4">Test certificate completed</div>
              <div class="col-md-8">
                <nb-radio-group name="testCertificate" class="row col-md-8" [(ngModel)]="report.lastinvoices.testCertificate">
                  <nb-radio [value]="1">Yes</nb-radio>
                  <nb-radio [value]="2">No</nb-radio>
                  <nb-radio [value]="3">All</nb-radio>
                </nb-radio-group>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col-md-4">Fiscal Year</div>
              <div class="col-md-8">
                <nb-radio-group name="fiscalMismatchLast" class="row col-md-8" [(ngModel)]="report.lastinvoices.fiscalYearMismatch">
                  <nb-radio [value]="1" checked>All</nb-radio>
                  <nb-radio [value]="2">Fiscal year mismatch</nb-radio>
                  <nb-radio [value]="3">Fiscal year match</nb-radio>
                </nb-radio-group>
              </div>
            </div> -->

            <div class="row mb-1">
              <div class="col-md-4">Fiscal Year</div>
              <div class="col-md-8">
                <ngx-doc-form-dropdown [(value)]="report.lastinvoices.fiscalYear" [options]="fiscalYearOptions"></ngx-doc-form-dropdown>
              </div>
            </div>

            <!-- <ngx-form-multi-select title="Finished product" [mode]="'column-select'" [(value)]="report.lastinvoices.finishedProducts" [businesses]="businesses" [finishedProductNames]="finishedProductNames"></ngx-form-multi-select> -->
            <!-- <ngx-form-js-date title="Issue date from" [(value)]="report.lastinvoices.issueDateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Issue date to" [(value)]="report.lastinvoices.issueDateTo"></ngx-form-js-date> -->
            <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.lastinvoices.dateType" (valueChange)="dateSelectionChanged(report.lastinvoices, $event)"></ngx-form-dropdown>
            <ngx-form-js-date title="Issue date from" [(value)]="report.lastinvoices.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Issue date to" [(value)]="report.lastinvoices.dateTo"></ngx-form-js-date>

            <div style="text-align: center">
              <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.lastinvoices, type: 'lastinvoices', pdf: true, xls: false }"></ng-container>
              <button class="btn btn-primary btn-lg" 
               (click)="onToggleExcel('lastinvoices', report.lastinvoices, false, 1)"
              >Table Preview
              </button>
              <button class="btn btn-primary btn-lg ml-2" 
               (click)="onToggleExcel('lastinvoices', report.lastinvoices, false, 2)"
              >Payment Record
              </button>
            </div>


          </nb-accordion-item-body>
        </nb-accordion-item>

        <!--------------------------------------------------- Box Report ------------------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('BOX')">
          <nb-accordion-item-header>Box Report</nb-accordion-item-header>
          <nb-accordion-item-body>

            <br><br>

            <ngx-doc-form-filter-select title="OC/DN Place of loading" [noBorder]="true" [options]="placeOfLoadingOptions"
              [(value)]="report.boxes.placeOfLoading">
            </ngx-doc-form-filter-select>

            <ngx-form-multi-select [checkbox]="true" title="Supplier(s) / SPO Recipient(s)" [(value)]="report.boxes.suppliers" [options]="businessOptionsMulti"></ngx-form-multi-select>
            <div class="mt-1"></div>
            <ngx-form-multi-select [checkbox]="true" title="Recipient(s) / SPO Customer(s)" [(value)]="report.boxes.customers" [options]="businessOptionsMulti"></ngx-form-multi-select>
            <div class="mt-1"></div>
            <ngx-form-multi-select [checkbox]="true" title="DN Recipient(s)" [(value)]="report.boxes.dnRecipients" [options]="businessOptionsMulti"></ngx-form-multi-select>

            <div class="mt-1"></div>
            <ngx-doc-form-filter-select title="Delivery Note"  [noBorder]="true" 
              [(value)]="report.boxes.dn" 
              [options]="dnOptions" 
              [separator]="'|'"
            >
            </ngx-doc-form-filter-select>

            <div style="height:0.2rem"></div>

            <ngx-form-multi-select
              title="Base product" [checkbox]="true" [(value)]="report.boxes.baseProducts" [options]="baseProductOptionsMulti">
            </ngx-form-multi-select>

            <ngx-form-multi-select
              title="Finished product" [checkbox]="true" [mode]="'column-select'" [(value)]="report.boxes.finishedProducts" [options]="finishedProductOptionsMulti">
            </ngx-form-multi-select>

            <div style="height:0.2rem"></div>


            <div class="row">
              <div class="col-md-4">Box Stock Status</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.boxes.stockStatus.notInInventory" />Not in Inventory yet</label>
                  <label><input type="checkbox" [(ngModel)]="report.boxes.stockStatus.onStock" />On Stock</label>
                  <label><input type="checkbox" [(ngModel)]="report.boxes.stockStatus.shipped" />Shipped to Customer</label>
                </div>
              </div>
            </div>

            <ngx-form-text title="Box Type" [(value)]="report.boxes.boxType"></ngx-form-text>

            <ngx-form-js-date title="Date Selection" [(value)]="report.boxes.date"></ngx-form-js-date>

            <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.boxes.dateType" (valueChange)="dateSelectionChanged(report.boxes, $event)"></ngx-form-dropdown>
            <ngx-form-js-date title="Dispatch date from" [(value)]="report.boxes.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Dispatch date to" [(value)]="report.boxes.dateTo"></ngx-form-js-date>

            <div class="row justify-content-center">             
              <button class="btn btn-primary btn-lg mr-2" (click)="report.boxes.expiryReport = false; report.boxes.simple = true; onToggleExcel('boxes', report.boxes)">Simple Box Table</button>
              <button class="btn btn-primary btn-lg mr-2" (click)="report.boxes.expiryReport = false; report.boxes.withOCBoxPrice = true;  report.boxes.simple = false; onToggleExcel('boxes', report.boxes)">Default Report Table</button>
              <button class="btn btn-primary btn-lg mr-2" (click)="report.boxes.expiryReport = false; onToggleExcel('boxes', report.boxes, false, 30)">Box Type Table</button>
              <button class="ml-2 btn btn-primary btn-lg" (click)="report.boxes.expiryReport = true; onToggleExcel('boxes', report.boxes)">Expiry Report Table w/o OC Prices</button>
              <button class="ml-2 btn btn-primary btn-lg" (click)="report.boxes.expiryReport = true; onToggleExcel('boxes', report.boxes, false, 1)">Expiry Report Table with OC Prices</button>
              <button class="ml-2 btn btn-primary btn-lg" (click)="report.boxes.expiryReport = true; $any(report.boxes).withEnRoute = true ; onToggleExcel('boxes', report.boxes, false, 1)">With En Route</button>
              <!-- <button class="btn btn-primary btn-lg" (click)="onToggleExcel('boxes', report.boxes, false, 0, true)">Inventory Preview</button> -->
            </div>

            <div style="height:8em"></div>


          </nb-accordion-item-body>
        </nb-accordion-item>
        
        
        <!--------------------------------------------------- Inventory Report ------------------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('INV')">
          <nb-accordion-item-header>Inventory</nb-accordion-item-header>
          <nb-accordion-item-body>

            <br><br>

            <ngx-doc-form-filter-select title="OC/DN Place of loading" [noBorder]="true" [options]="placeOfLoadingOptions"
              [(value)]="report.inventory.placeOfLoading">
            </ngx-doc-form-filter-select>

            <ngx-form-multi-select [checkbox]="true" title="Supplier(s) / SPO Recipient(s)" [(value)]="report.inventory.suppliers" [options]="businessOptionsMulti"></ngx-form-multi-select>
            <div class="mt-1"></div>
            <ngx-form-multi-select [checkbox]="true" title="Recipient(s) / SPO Customer(s)" [(value)]="report.inventory.customers" [options]="businessOptionsMulti"></ngx-form-multi-select>
            <div class="mt-1"></div>
            <ngx-form-multi-select [checkbox]="true" title="DN Recipient(s)" [(value)]="report.inventory.dnRecipients" [options]="businessOptionsMulti"></ngx-form-multi-select>
            <div style="height:0.2rem"></div>

            <ngx-form-multi-select
              title="Base product" [checkbox]="true" [(value)]="report.inventory.baseProducts" [options]="baseProductOptionsMulti">
            </ngx-form-multi-select>

            <ngx-form-multi-select
              title="Finished product" [checkbox]="true" [mode]="'column-select'" [(value)]="report.inventory.finishedProducts" [options]="finishedProductOptionsMulti">
            </ngx-form-multi-select>

            <div style="height:0.2rem"></div>

            <div class="row">
              <div class="col-md-4">Box Stock Status</div>
              <div class="col-md-8">
                <div class="checkbox row col-md-8">
                  <label><input type="checkbox" [(ngModel)]="report.inventory.stockStatus.notInInventory" />Not in Inventory yet</label>
                  <label><input type="checkbox" [(ngModel)]="report.inventory.stockStatus.onStock" />On Stock</label>
                  <label><input type="checkbox" [(ngModel)]="report.inventory.stockStatus.shipped" />Shipped to Customer</label>
                </div>
              </div>
            </div>



            <ngx-form-js-date title="Date Selection" [(value)]="report.inventory.date"></ngx-form-js-date>

            <!-- <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.inventory.dateType" (valueChange)="dateSelectionChanged(report.inventory, $event)"></ngx-form-dropdown>
            <ngx-form-js-date title="Issue date from" [(value)]="report.inventory.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Issue date to" [(value)]="report.inventory.dateTo"></ngx-form-js-date> -->

            <div class="row justify-content-center">             
              <button class="btn btn-primary btn-lg" (click)="onToggleExcel('inventory', report.inventory)">Table Preview</button>
              <button class="btn btn-primary btn-lg" (click)="onTogglePrinter('inventory', report.inventory)">PDF preview</button>
              <button class="btn btn-primary btn-lg" (click)="onToggleExcel('inventory', report.inventory, false, 10)">Stock Summary Table</button>
              <button class="btn btn-primary btn-lg" (click)="onToggleExcel('inventory', report.inventoryMonthly, false, 11)">Monthly Inventory</button>
              <!-- <button class="btn btn-primary btn-lg" (click)="onToggleExcel('inventory', report.inventory, false, 0, true)">Inventory Preview</button> -->
            </div>

            <div style="height:8em"></div>


          </nb-accordion-item-body>
        </nb-accordion-item>
        
        <!-------------------------------------------------------- track spo payment --------------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('TSP')">
          <nb-accordion-item-header>Track SPO Payment</nb-accordion-item-header>
          <nb-accordion-item-body>

            <ngx-form-multi-select title="SPO Recipients(s)" [checkbox]="true" [(value)]="report.spopayment.recipients" [options]="businessOptionsMulti"></ngx-form-multi-select>
            <div class="mt-1"></div>
            <ngx-form-multi-select title="Customer Reference: Name(s)" [checkbox]="true" [(value)]="report.spopayment.customerReference" [options]="businessOptionsMulti"></ngx-form-multi-select>
            <div class="mt-1"></div>
            <ngx-form-multi-select title="Customer Reference: Document Number(s)" [checkbox]="true" [(value)]="report.spopayment.customerDocumentNumber" [options]="customerDocOptionsMulti"></ngx-form-multi-select>

            <div class="row my-1">
              <div class="col-md-4">Fiscal Year</div>
              <div class="col-md-8">
                <ngx-doc-form-dropdown [(value)]="report.spopayment.fiscalYear" [options]="fiscalYearOptions"></ngx-doc-form-dropdown>
              </div>
            </div>
  
            <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.spopayment.dateType" (valueChange)="dateSelectionChanged(report.spopayment, $event)"></ngx-form-dropdown>
            <ngx-form-js-date title="SPO IN Issue Date From" [(value)]="report.spopayment.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="SPO IN Issue Date To" [(value)]="report.spopayment.dateTo"></ngx-form-js-date>

            <ngx-form-check title="Not Manually Completed Only" [(value)]="report.spopayment.noncompleteOnly"></ngx-form-check>

            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.spopayment, type: 'spopayment', xls: true }"></ng-container>

            <div style="height:15rem"></div>

          </nb-accordion-item-body>
        </nb-accordion-item>
        
        <!------------------------------------------------ customer overview ------------------------------------------->

        <nb-accordion-item *ngIf="this.auth?.user?.erpRoles.admin || this.auth?.user?.erpRoles.customerReport"
          [expanded]="shallExpand('CO')" (collapsedChange)="collapsedChange('CO')">
          <nb-accordion-item-header>Business Overview</nb-accordion-item-header>
          <nb-accordion-item-body>

            <div class="row mt-2">
              <div class="col-md-4">
                Quick Links (BU Filter)<br>
              </div>
              <div class="col-md-8">
                <div class="d-inline-block col-md-2">
                  <div class="d-inline-block">
                    <ngx-doc-form-checkbox 
                      [(value)]="report.customeroverview.buFilter.all"
                      (valueChange)="report.customeroverview.buFilter.machinery = report.customeroverview.buFilter.energy = report.customeroverview.buFilter.composite = false"
                      >
                    </ngx-doc-form-checkbox></div>
                  <div class="d-inline-block">All</div>
                </div>
                <div class="d-inline-block col-md-2">
                  <div class="d-inline-block"><ngx-doc-form-checkbox [(value)]="report.customeroverview.buFilter.machinery" (valueChange)="report.customeroverview.buFilter.all = false"></ngx-doc-form-checkbox></div>
                  <div class="d-inline-block">Machinery BU</div>
                </div>
                <div class="d-inline-block col-md-2">
                  <div class="d-inline-block"><ngx-doc-form-checkbox [(value)]="report.customeroverview.buFilter.energy" (valueChange)="report.customeroverview.buFilter.all = false"></ngx-doc-form-checkbox></div>
                  <div class="d-inline-block">Energy Materials</div>
                </div>
                <div class="d-inline-block col-md-2">
                  <div class="d-inline-block"><ngx-doc-form-checkbox [(value)]="report.customeroverview.buFilter.composite" (valueChange)="report.customeroverview.buFilter.all = false"></ngx-doc-form-checkbox></div>
                  <div class="d-inline-block">Composites</div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-4"></div>
              <div class="col-md-8 mb-2">
                <div class="col-md-4">
                  <div class="d-inline-block"><ngx-doc-form-checkbox [(value)]="report.customeroverview.sortByManager"></ngx-doc-form-checkbox></div>
                  <div class="d-inline-block">Sort by Sales Manager</div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-4">Quick Links (Preferred Date)</div>
              <div class="col-md-4">
                <span class="mr-3">Weekly Overview:</span>
                <button class="nrk-button mr-3" (click)="quickLink(0)">Current CW</button>
                <button class="nrk-button mr-3" (click)="quickLink(1)">Last CW</button>
              </div>
              <div class="col-md-4">
                <span class="mr-3">Monthly Overview:</span>
                <button class="nrk-button mr-3" (click)="quickLink(2)">Current CM</button>
                <button class="nrk-button mr-3" (click)="quickLink(3)">Last CM</button>
              </div>
            </div>

            <!-- <div class="row mt-2">
              <div class="col-md-4">
                <div style="display:inline-block;padding-right:1rem;">Quick Links (Date Selection)</div>
                <div style="display:inline-block"><ngx-doc-form-date [(value)]="$any(report).customeroverview.quickLinkDateSelection"></ngx-doc-form-date></div>
              </div>
              <div class="col-md-4">
                <span class="mr-3">Weekly Overview:</span>
                <button class="nrk-button mr-3" (click)="quickLink(5)">Current CW</button>
                <button class="nrk-button mr-3" (click)="quickLink(6)">Last CW</button>
              </div>
              <div class="col-md-4">
                <span class="mr-3">Monthly Overview:</span>
                <button class="nrk-button mr-3" (click)="quickLink(7)">Current CM</button>
                <button class="nrk-button mr-3" (click)="quickLink(8)">Last CM</button>
              </div>
            </div> -->
            <!-- <div class="row mt-2">
              <div class="col-md-4">
                Quick Links (Business Unit)<br>
              </div>
              <div class="col-md-8">
                <button class="nrk-button mr-3 col-md-2" (click)="quickLink(10)">Machinery BU</button>
                <button class="nrk-button mr-3 col-md-2" (click)="quickLink(11)">Energy Materials</button>
                <button class="nrk-button col-md-2" (click)="quickLink(12)">Composites</button>
                <div class="ml-1 mt-1 d-inline-block col-md-4 align-middle">
                  <div class="d-inline-block"><ngx-doc-form-checkbox [(value)]="report.customeroverview.sortByManager"></ngx-doc-form-checkbox></div>
                  <div class="d-inline-block">Sort by Sales Manager</div>
                </div>
              </div>
            </div> -->

            <hr>

            <ng-container *ngTemplateOutlet="presetTemplate; context: { $implicit: report.customeroverview, type: 'customeroverview' }"></ng-container>

            <ngx-form-dropdown title="RSM" [(value)]="report.customeroverview.manager" [options]="userContactOptions">
            </ngx-form-dropdown>
            <ngx-form-dropdown title="Issuer" [(value)]="report.customeroverview.issuer" [options]="issuerOptions">
            </ngx-form-dropdown>
            <ngx-doc-form-filter-select title="Country"  [noBorder]="true" [(value)]="report.customeroverview.country" [options]="countryOptions">
            </ngx-doc-form-filter-select>
            <ngx-form-multi-select title="Customer(s)" [checkbox]="true" [(value)]="report.customeroverview.customers" [options]="businessOptionsMulti"></ngx-form-multi-select>
            <ngx-form-multi-select title="Business unit(s)" [checkbox]="true" [(value)]="report.customeroverview.businessUnits" [options]="businessUnitOptionsMulti"></ngx-form-multi-select>
  
            <ngx-form-dropdown title="Date Selection" [options]="dateSelectionOptions" [value]="report.customeroverview.dateType" (valueChange)="dateSelectionChanged(report.customeroverview, $event)"></ngx-form-dropdown>
            <ngx-form-js-date title="Issue date from" [(value)]="report.customeroverview.dateFrom"></ngx-form-js-date>
            <ngx-form-js-date title="Issue date to" [(value)]="report.customeroverview.dateTo"></ngx-form-js-date>

            <!-- <ngx-form-column-select title="Trial" [textfield]="true" [trial]="true" (productSelected)="report.customeroverview.trial = $event" [businesses]="businesses" [finishedProductNames]="finishedProductNames"></ngx-form-column-select> -->
            <!-- <ngx-form-column-select title="FinishedProduct" [textfield]="true" (productSelected)="report.customeroverview.finishedProduct = $event" [businesses]="businesses" [finishedProductNames]="finishedProductNames"></ngx-form-column-select> -->
            <ngx-form-multi-select [checkbox]="true" title="Finished product" [mode]="'column-select'" [(value)]="report.customeroverview.finishedProducts" [options]="finishedProductOptionsMulti">
            </ngx-form-multi-select>
        
            <div class="row">
              <div class="col-md-4">Succession</div>
              <div class="col-md-8">
                <nb-radio-group name="sortorder" class="row col-md-8" [(ngModel)]="searchorder">
                  <nb-radio [value]="1"
                    (valueChange)="report.customeroverview.sort=['lastinvoices', 'dueinvoices', 'orders', 'noninvoiced', 'srpfin', 'srnoninvoiced', 'offers']">
                    IN - Due IN - OR - NOC - PFIN - NOC(SR) - OF</nb-radio>
                  <nb-radio [value]="2"
                    (valueChange)="report.customeroverview.sort=['offers', 'noninvoiced', 'srnoninvoiced', 'dueinvoices', 'orders', 'lastinvoices', 'srpfin']">
                    OF - NOC - NOC(SR) - Due IN - OR - IN - PFIN</nb-radio>
                </nb-radio-group>
              </div>
            </div>

            <p>Attached reports:</p>
            <div>
              <div class="row ml-3 my-2"><div class="col-md-6"></div><button class="nrk-button" (click)="toggleShowAllReports()">toggle show all reports</button></div>
              <ng-container *ngFor="let report of report.customeroverview.attachedReports | keyvalue">
                <ng-container *ngTemplateOutlet="coreport; context: { $implicit: report }"></ng-container>
              </ng-container>
            </div>
  
<!--            <p>Attached reports:</p>
            <div style="padding-left: 1em;">
              <!~~ <ngx-form-check title="Invoices" [(value)]="report.customeroverview.attachedReports.lastinvoices.show"></ngx-form-check>
              <ngx-form-check title="Non invoiced OCs" [(value)]="report.customeroverview.attachedReports.noninvoiced.show"></ngx-form-check>
              <ngx-form-check title="Due invoices" [(value)]="report.customeroverview.attachedReports.dueinvoices.show"></ngx-form-check>
              <ngx-form-check title="Profroma invoices (Sample requests)" [(value)]="report.customeroverview.attachedReports.srpfin.show"></ngx-form-check>
              <ngx-form-check title="Non invoiced OCs (Sample requests)" [(value)]="report.customeroverview.attachedReports.srnoninvoiced.show"></ngx-form-check> ~~>
              <ng-container *ngFor="let report of report.customeroverview.attachedReports | keyvalue">
                <ng-container *ngTemplateOutlet="coreport; context: { $implicit: report }"></ng-container>
              </ng-container>
            </div>
-->
            <br/>
            <br/>
            <ng-container *ngTemplateOutlet="footer; context: { $implicit: report.customeroverview, type: 'customeroverview', pdf: true }"></ng-container>

          </nb-accordion-item-body>
        </nb-accordion-item>

        <!--------------------------------------------------- Product overview --------------------------------------------------->

        <nb-accordion-item [expanded]="shallExpand('PO')">
          <nb-accordion-item-header>Product overview</nb-accordion-item-header>
          <nb-accordion-item-body>

            <br><br>
            <h4>Base Products</h4>
            <ngx-form-multi-select [checkbox]="true" title="Business Unit(s)" [(value)]="report.baseProducts.businessUnits" [options]="businessUnitOptionsMulti"></ngx-form-multi-select>
            <ngx-form-multi-select
              title="Finished product" [checkbox]="true" [mode]="'column-select'" [(value)]="report.baseProducts.products" [options]="finishedProductOptionsMulti">
            </ngx-form-multi-select>
            <div class="row justify-content-center">             
              <button class="btn btn-primary btn-lg" (click)="onToggleExcel('baseProducts', report.baseProducts)">Base products</button>
            </div>

            <br><br>
            <h4>Finished Products</h4>
            <ngx-form-multi-select [checkbox]="true" title="Business Unit(s)" [(value)]="report.finishedProducts.businessUnits" [options]="businessUnitOptionsMulti"></ngx-form-multi-select>
            <ngx-form-multi-select
              title="Finished product" [checkbox]="true" [mode]="'column-select'" [(value)]="report.finishedProducts.products" [options]="finishedProductOptionsMulti">
            </ngx-form-multi-select>
            <div class="row justify-content-center">             
              <button class="btn btn-primary btn-lg" (click)="onToggleExcel('finishedProducts', report.finishedProducts)">FinishedProducts</button>
            </div>
            <br><br>
            <div style="height:35em"></div>

          </nb-accordion-item-body>
        </nb-accordion-item>



      </nb-accordion>
    </ngx-page-container>
  </div>
</ng-sidebar-container>

<!-- <ngx-reports-printer #reportsPrinter style="display:none" [search]="search" [pdfSidebar]="pdfSidebar" [businesses]="businesses"
[businessUnits]="businessUnits" [users]="users" (back)="hideSidebar()"></ngx-reports-printer> -->
<div style="display:none">
  <!-- <ng-container *ngIf="reportType == 'customeroverview'; then customerPrinter; else reportsPrinter"></ng-container> -->
  <ngx-customer-printer *ngIf="reportType == 'customeroverview'" [search]="search" [pdfSidebar]="pdfSidebar" (back)="hideSidebar()"></ngx-customer-printer>
  <ngx-reports-printer #reportsPrinterComp [search]="search" [pdfSidebar]="pdfSidebar" (back)="hideSidebar()"></ngx-reports-printer>
</div>

<ng-template #customerPrinter>
  <ngx-customer-printer [search]="search" [pdfSidebar]="pdfSidebar" (back)="hideSidebar()"></ngx-customer-printer>
</ng-template>

<ng-template #reportsPrinter>
  <ngx-reports-printer #reportsPrinterComp [search]="search" [pdfSidebar]="pdfSidebar" (back)="hideSidebar()"></ngx-reports-printer>
</ng-template>

<!-- <ng-template #coreport let-report>
  <div class="row">
    <div class="col-md-4">{{report.value.text}}</div>
    <div class="checkbox col-md-8">
      <input type="checkbox" [(ngModel)]="report.value.show" />
      <label>Number of documents:</label>
      <input type="text" [(ngModel)]="report.value.limit" />
    </div>
  </div>
</ng-template> -->

<ng-template #coreport let-report>
  <div class="row">
    <div class="col-md-6">{{report.value.text}}</div>
    <div class="checkbox col-md-6">
      <input type="checkbox" [(ngModel)]="report.value.show" />
      <label class="ml-1">Number of documents:</label>
      <input class="ml-1" style="width:3em" type="text" [(ngModel)]="report.value.limit" [attr.disabled]="report.value.showAll ? true : null"/>
      <input type="checkbox" class="ml-3" [(ngModel)]="report.value.showAll" />
      <label class="ml-1">All</label>
    </div>
  </div>
</ng-template>



